<div *ngIf="!isBlockedSeat; else blockedSeat">
<div *ngIf="openedFrom!='web'; else webView" [ngClass]="{'bottomSlider':isSlideIn && !isBlockedSeat,'bottomSlideOut':!isSlideIn}">
    <div *ngIf="isSeatClicked; else seatView">
    <section class="emp-Details" *ngIf="isSlideIn">
        <div class="closes">
            <img src="assets/slideClose.svg" (click)="close($event)"/>
        </div>
      <div *ngFor="let detail of displayData| slice:0:1">
              <p class="empName"> {{detail.employeeName}} </p>
              <div class="emp-floor-info">
                <span *ngIf="detail.premiseName" class="premise-name"> {{detail.premiseName}}</span>
                <img *ngIf="detail.premiseName" src="assets/slide-dot.svg" class="" alt="seat-icon">
              <span *ngIf="detail.teamName" class="teamName"> {{detail.teamName}} </span>
            </div>
              <span class="seatName">
                  <img src="assets/seat-icon.svg" class="" alt="seat-icon">
                  {{bookingDisplaySeat}} 
              </span>
              <div class="emp-time">
                  <span> {{detail.startTime | formatDateTime : timeZone}} -
                      {{detail.endTime | formatDateTime : timeZone }} </span>
                  <span *ngIf="detail.signInTime>0"> Checkin Time - {{detail.signInTime | formatDateTime : timeZone }}</span>
                  <span *ngIf="detail.seatStatus" [ngStyle]="{'color': getStatusColor(detail)}"> {{detail.seatStatus}} </span>
              </div>
          </div>
          
    </section>
</div>
<ng-template #seatView>
    <section class="emp-Details" *ngIf="isSlideIn">
        <div class="closes">
            <img src="assets/slideClose.svg" (click)="close($event)"/>
        </div>
      <div>
              <p class="empName"> {{seatStatus}} </p>
              <span class="seatName">
                  <img src="assets/seat-icon.svg" class="" alt="seat-icon">
                  {{selectedSearchSeat.seatName}}
              </span>
          </div>
          
    </section>
</ng-template>
  </div>
  <ng-template #webView>
    <div *ngIf="isSeatClicked  else seatWebView">
    <section class="seatDetails center"
        [ngStyle]="{'position': 'fixed', 'left': xPos+'px', 'top': yPos+'px', 'transition': 'all 1s'}"
        [ngClass]="{'rightToolTip': bookingPopUpDirection, 'leftToolTip': !bookingPopUpDirection}">
        <img src="assets/booking-close.svg" class="close" (click)="close($event)" alt="close">
        <div *ngFor="let detail of displayData| slice:0:1" class="user">
            <div>
                <p class="empName"> {{detail.employeeName}} </p>
                <div class="emp-floor-info">
                    <span *ngIf="detail.premiseName" class="premise-name"> {{detail.premiseName}}</span>
                    <img *ngIf="detail.premiseName" src="assets/slide-dot.svg" class="" alt="seat-icon">
                  <span *ngIf="detail.teamName" class="teamName"> {{detail.teamName}} </span>
                </div>
                <span class="seatName">
                    <img src="assets/seat-icon.svg" class="" alt="seat-icon">
                    {{bookingDisplaySeat}} 
                </span>
                <span> {{detail.startTime | formatDateTime : timeZone}} -
                    {{detail.endTime | formatDateTime : timeZone }} </span>
                <span *ngIf="detail.signInTime>0"> Checkin Time - {{detail.signInTime | formatDateTime : timeZone }}</span>
                <span *ngIf="detail.seatStatus" [ngStyle]="{'color': getStatusColor(detail)}"> {{detail.seatStatus}} </span>
            </div>
        </div>
    </section>
</div>
<ng-template #seatWebView>
    <section class="seatDetails center"
    [ngStyle]="{'position': 'fixed', 'left': xPos+'px', 'top': yPos+'px', 'transition': 'all 1s'}"
    [ngClass]="{'seatWebView': selectedSearchInfo==='seat','rightToolTip': bookingPopUpDirection, 'leftToolTip': !bookingPopUpDirection}">
    <img src="assets/booking-close.svg" class="close" (click)="close($event)" alt="close">
    <div class="user">
        <div>
            <p class="empName"> {{seatStatus}} </p>
            <span class="seatName">
                <img src="assets/seat-icon.svg" class="" alt="seat-icon">
                {{selectedSearchSeat.seatName}} 
            </span>
        </div>
    </div>
</section>
</ng-template>
</ng-template>
</div>
    <ng-template #blockedSeat>
        <section class="seatDetails center"
            [ngStyle]="{'position': 'fixed', 'left': xPos+'px', 'top': yPos+'px', 'transition': 'all 1s'}">
            <img src="assets/close.svg" class="close" (click)="close($event)" alt="close">
            <div class="user">
                <div>
                    <p style="margin:0;padding:0"> You cannot select this seat as it may belong to another team or blocked
                        by the admin of your company.</p>
                </div>
            </div>
        </section>
    </ng-template>

